<template>
  <div class="form-group form-row">
    <label class="col-sm-4 col-form-label">Danger zone</label>
    <div class="col-sm-8">
      <p class="form-text">Once you delete a template, there is no going back. Please be certain. </p>
      <button type="button" class="btn btn-danger" @click="remove">Delete Template</button>
    </div>
  </div>
</template>

<script>
  import * as action from '@/store/action-types'

  export default {
    name: 'template-setting-delete',
    props: {
      templateId: {
        type: String,
        required: true
      }
    },
    methods: {
      remove () {
        this.$store.dispatch(action.TEMPLATE_DELETE, {
          templateId: this.templateId
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/template-settings/template-setting-delete.vue